import { useIntl } from 'react-intl';

import type { OrderStatus } from '#domain/Order.ts';

import { OrderStatusData } from './OrderStatusData.ts';

type OrderStateProps = { status: OrderStatus };

export const OrderState = ({ status }: OrderStateProps) => {
    const intl = useIntl();
    const { color, icon, id } = OrderStatusData[status];

    return (
        <span className='white-space-nowrap'>
            <span className={`label label-${color}`}>
                <span className='display-flex align-items-center gap-5'>
                    <span className={`uikit-icon icon-${icon}`} />
                    <span>{intl.formatMessage({ id })}</span>
                </span>
            </span>
        </span>
    );
};
